import React from 'react';
import { observer } from 'mobx-react';

import { DateHelper } from '../../../helpers/DateHelper';
import { StockLabel } from '../stock-label';
import { ImageCarouselMobile } from '../image-carousel-mobile';
import { Separator } from '../separator';
import { ActionButtonContainer } from '../action-button-container';
import { CompareCheckbox } from '../../../common/compare-checkbox';
import { ProductStore } from '../stores/ProductStore';
import styles from './TopBodyMobile.css';
import { Plans } from '../../../common/plans';
import imagesSelector from '../../../assets/images';

const TopBodyMobile = observer(() => {
  const { product } = ProductStore;
  return (
    <section>
      <h1 className={styles.title}>
        {product.name}
      </h1>
      <ImageCarouselMobile />
      <div className={styles.textContainer}>
        <div className={styles.priceContainer}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
              }}
            >
              <p className={styles.price}>
                ${product.financing.priceString}
              </p>
              <p className={styles.priceSubtext}>
                Contado
              </p>
            </div>
            <div><img src={imagesSelector('uruguay')[1]} alt="Bandera Uruguay" style={{ width: 60 }} /></div>
          </div>
          <Plans productId={product.id} size="85px" />
        </div>
        {
          !product.isService &&
          <div className={styles.stockContainer}>
            <StockLabel darkMode product={product} />
            <p className={styles.stockLastUpdate}>
              Actualizado {DateHelper.toTimeLocalizedString(product.stockLevelLastUpdate)}
            </p>
          </div>
        }
        {
          product.isService && !product.isWarranty &&
          <p className={styles.serviceText}>
            { product.serviceAvailabilityText }
          </p>
        }
        <ActionButtonContainer
          className={styles.actionButtonContainer}
          product={product}
        />
        <CompareCheckbox product={product} />
        <Separator />
      </div>
    </section>
  );
});

export { TopBodyMobile };



// WEBPACK FOOTER //
// ./src/pages/product-detail/top-body-mobile/TopBodyMobile.jsx